import SideDoor from "./custom/sideDoor/sideDoor";

const customArticleConfig = [
    {
        _id: "613ef5ca8c4df34bbe2ab627",
        component: SideDoor
    }
];

export default customArticleConfig;